import { useNavigate } from 'react-router-dom';

import { PageBanner } from '@/ui/PageBanner';
import { Button } from '@/ui/base/button';

import { useSituacaoOperacionalDoPortal } from './gating';

interface GatingBannerProps {
  /** Esconde o atalho quando o destino dele é a própria tela. */
  hideCta?: boolean;
  /**
   * Caminho da tela que monta a faixa. O atalho cujo destino é esta mesma
   * tela não é renderizado (regra de interface 7: levaria a lugar nenhum); os
   * atalhos para outras telas continuam.
   */
  telaAtual?: string;
}

/**
 * Aviso único de pendência operacional do Portal do Credenciado — o
 * `GatingBanner` do protótipo: `PageBanner` no tom da severidade, título,
 * detalhe e o atalho para resolver. Vai para o slot logo abaixo do
 * `PageHeader`, então é seguro montar sempre; sem pendência não renderiza.
 */
export function GatingBanner({ hideCta, telaAtual }: GatingBannerProps) {
  const navigate = useNavigate();
  const { data: situacao } = useSituacaoOperacionalDoPortal();

  if (!situacao || situacao.motivo === 'OK') {
    return null;
  }

  const { cta } = situacao;

  return (
    <PageBanner tone={situacao.severidade} title={situacao.titulo} description={situacao.detalhe}>
      {cta && !hideCta && cta.caminho !== telaAtual && (
        <div className="pt-1">
          <Button
            size="sm"
            variant={situacao.severidade === 'destructive' ? 'destructive' : 'default'}
            onClick={() => navigate(cta.caminho)}
          >
            {cta.rotulo}
          </Button>
        </div>
      )}
    </PageBanner>
  );
}
